module.exports = __webpack_public_path__ + "static/img1-b435cd0fc1ad450b3296ea6ea13e8e50.jpeg";